export default __webpack_public_path__ + "static/media/EC.6f40aa28.svg";